import { gql } from '@apollo/client';

import {
  DASHBOARD_SUBSCRIPTION_FIELDS,
  SUB_MGMT_SUBSCRIPTION_FIELDS,
  TAG_FIELDS,
} from './fragments';

/**
 * Queries minimum required data to render lazy-load dashboard.
 *
 * We also get cart UUIDs just for a count of overall active carts to determine
 * whether or not to use pre-credit total.
 */
export const GET_SUBSCRIPTION_UUIDS_V2 = gql`
  query getSubscriptionUUIDsV2 {
    dashboardSubscriptionsV2 {
      uuid
      startWeek
      endWeek
      status
      displayName
      carts {
        uuid
      }
      status
    }
  }
`;

export const GET_SUBSCRIPTION_BY_ID_V2 = gql`
  query getSubscriptionV2ByUuid($uuid: UUID!) {
    subscriptionV2(uuid: $uuid) {
      ...subMgmtFields
    }
  }
  ${SUB_MGMT_SUBSCRIPTION_FIELDS}
  ${TAG_FIELDS}
`;

export const GET_SUBSCRIPTION_BY_ID_DASHBOARD_V2 = gql`
  query getSubscriptionV2ByUuidDashboard($uuid: UUID!) {
    subscriptionV2(uuid: $uuid) {
      ...dashboardSubscription
    }
  }
  ${DASHBOARD_SUBSCRIPTION_FIELDS}
  ${TAG_FIELDS}
`;
